import { Box, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { CreateReportPropertyFormData } from '../../models';
import { currencyFormatter } from '../../utils';
import { Home } from '../icons';

type ReportHeaderProps = CreateReportPropertyFormData & {
  monthlyCashFlow: number[] | undefined;
};

export function ReportHeader({
  monthlyCashFlow,
  street,
  unit,
  city,
  state,
  zipCode
}: ReportHeaderProps) {
  const [monthlyCashFlowAvg, setMonthlyCashFlowAvg] = useState<number>(0.0);

  useEffect(() => {
    if (monthlyCashFlow) setMonthlyCashFlowAvg(monthlyCashFlow?.reduce((a, b) => a + b, 0) / 12);
  }, [monthlyCashFlow]);
  console.log(Home);

  return (
    <Flex p="10" justify="center" align="center" fontFamily="Montserrat" color="#5A5A5A">
      <Box px="2">
        <Home />
      </Box>
      <Box px="2">
        <Text fontSize="4xl" fontWeight="bold">
          {`${street}`}
        </Text>
        {unit ? (
          <Text fontSize="4xl" fontWeight="bold">
            {`${unit || ''}`}
          </Text>
        ) : null}
        <Text fontSize="4xl" fontWeight="bold">{`${city}, ${state} ${zipCode}`}</Text>
        <Flex>
          {monthlyCashFlowAvg >= 0 ? (
            <img src="/images/piggy.png" alt="piggy" />
          ) : (
            <img className="w-8 h-8 mt-3 mr-2" src="/images/crying-emoji.png" alt="crying-emoji" />
          )}
          <Text
            mt="4"
            fontSize="xl"
            color={monthlyCashFlowAvg >= 0 ? '#81CCA4' : '#C00000'}
          >{`${currencyFormatter(monthlyCashFlowAvg)} monthly cash flow`}</Text>
        </Flex>
      </Box>
    </Flex>
  );
}

export default ReportHeader;
